exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".transaction-error{display:block;margin-bottom:18px;background-color:#910f13;padding:10px 5px}.selected-tickets .item .js-remove:disabled,.selected-tickets .item .js-remove[disabled=disabled]{color:#ddd;cursor:default}.selected-tickets .item .js-remove:disabled:hover,.selected-tickets .item .js-remove[disabled=disabled]:hover{color:#ddd}.theatre-note{margin-bottom:30px;margin-top:-45px;background:#d3d3d3;padding:10px;list-style-position:inside;text-align:center}.theatre-note li{font-size:14px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-101224a6","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Theatre/Theatre.vue
// module id = 157
// module chunks = 0